import { Rest, baseUrl } from '../../../lib/rest'
import * as util from '../../auth/components/util'
import { loadProject } from '../../project/actions'

export const lineitemsUrl = `${baseUrl}/lineitems/v1/get`
export const usersUrl = `${baseUrl}/users/v1/get`
export const userAssignUrl = `${baseUrl}/users/v1`

export function loadLineitems(request, onSaveAssignedUser) {
  return dispatch => {    
    dispatch(commenceFetch())
    return Rest.get(lineitemsUrl, request)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            const { data, meta } = res;
            const payload = { 
              lineitems: data, 
              meta, 
              onSaveAssignedUser 
            };
            dispatch(onFetchSuccess(payload))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function loadLineitemsByProjectId(request) {
  return dispatch => {    
    dispatch(commenceFetch())
    return Rest.get(lineitemsUrl, request)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            const { data } = res;
            const payload = { 
              projectLineitems: data, 
              projectId: request.extProjectId
            };
            dispatch(onFetchLineitemsByProjectIdSuccess(payload))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function loadUsers(request) {
  return dispatch => {    
    dispatch(commenceFetch())
    return Rest.get(usersUrl, request)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            const { data } = res;
            const payload = { users: data };
            dispatch(onFetchUsersSuccess(payload))
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function updateAssignedUser(lineitemId, request, type, filter, projectId) {
  return dispatch => {    
    dispatch(commenceFetch())
    return Rest.post(`${userAssignUrl}/${lineitemId}/${type}`, request)
    .then(util.handleErrors)
    .then(res => res.json())
    .then(res => {
          if (res != null && util.hasError(res)){
              return dispatch(util.showCustomError(res))
          } 
          else {
            dispatch(onUpdateAssignedUserSuccuss(request))
            if (projectId) {
              dispatch(loadProject(projectId, lineitemId))
            } 
            if (filter) {
              dispatch(loadLineitems(filter, true))
            }
          }
      }).catch(err => {
        return dispatch(util.onServerError(err));
      });
  }
}

export function reset() {
  return dispatch => {
    dispatch(resetError())
  }
}

export function setLimitOffsetSort(payload) {
  return {
    type: "LIMIT_OFFSET_SORT_SET",
    payload
  }
}

export function resetFilters(payload) {
  return {
    type: "RESET_FILTERS",
  }
}

export function switchStateFilter(payload) {
  return {
    type: "STATE_FILTER_SELECT_OPTION",
    payload
  }
}

export function switchSearchFilter(payload) {
  return {
    type: "SEARCH_FILTER_SELECT_OPTION",
    payload
  }
}

export function setSearchQuery(payload) {
  return {
    type: "SEARCHBAR_NEW_QUERY",
    payload
  }
}

function commenceFetch() {
  return {
    type: "LINEITEMS_COMMENCE_FETCH"
  }
}

function onFetchSuccess(payload) {
  return {
    type: "LINEITEMS_DID_LOAD",
    payload
  }
}

function onFetchLineitemsByProjectIdSuccess(payload) {
  return {
    type: "LINEITEMS_BY_PROJECTID_DID_LOAD",
    payload
  }
}

function onFetchUsersSuccess(payload) {
  return {
    type: "USERS_DID_LOAD",
    payload
  }
}

function onUpdateAssignedUserSuccuss(payload) {
  return {
    type: "USER_ASSIGNMENT_UPDATE_SUCCUSS",
    payload
  }
}

function resetError() {
  return {
    type: "LINEITEMS_RESET_ERROR"
  }
}